import request from '@/utils/response.js';


// 标的列表
export function getSiteConfig(params) {
    return request({
        url: '/api/common/getSiteConfig',
        method: 'get',
        params
    })
}
